import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { adminApi } from '../../admin/api';
import { ErrorResponse } from '@store/ReduxTypes';
import { AdminRequest } from './AdminPanelTypes';

/** Единственная точка выполнения запросов административной панели. */
export const adminRequestOperation = createAsyncThunk<
  { key: string; data: unknown },
  AdminRequest,
  { rejectValue: { key: string; message: string } }
>('adminPanel/request', async ({ key, method = 'get', url, data, params }, { rejectWithValue }) => {
  try {
    const response = await adminApi.request({ method, url, data, params });
    return { key, data: response.data };
  } catch (error) {
    const axiosError = error as AxiosError<ErrorResponse>;
    return rejectWithValue({
      key,
      message:
        axiosError.response?.data?.message ||
        axiosError.response?.data?.detail ||
        axiosError.message,
    });
  }
});
